// removed by extract-text-webpack-plugin
module.exports = {"baseInfo":"index__baseInfo___3j2Uh"};


//////////////////
// WEBPACK FOOTER
// ./src/views/RealTimeReport/index.less
// module id = 652
// module chunks = 3